import ToggleFFXIV from '@/app/components/ToggleFFXIV';
import TooltipWithIconFFXIV from '@/app/components/TooltipWithIconFFXIV';
import { useGameModeSettingsContext } from '@/app/providers/GameModeSettingsProvider';
import { useGlobalPopup } from '@/app/providers/GlobalPopupProvider';
import { useTranslation } from '@/hooks/useTranslation';
import { CustomModeSettings } from '@/lib/types/common/GameModeAdvancedSettings';
import React from 'react'

const HazardSelector = () => {
    const { t } = useTranslation();
    const { showPopup } = useGlobalPopup();
    const { settings, updateSettings, isGameMaster } = useGameModeSettingsContext();

    const handleHazardModeToggle = (hasHazards: boolean) => {
        if (isGameMaster) {
            updateSettings({ hasHazards } as Partial<CustomModeSettings>);
        } else {
            showPopup({
                type: 'error',
                message: t('lobby.onlyGameMasterCan'),
            });
        }
    };

    if (!('hasHazards' in settings)) {
        return null;
    }

    const customSettings = settings as CustomModeSettings;

    return (
        <div className="flex items-center gap-4">
            <ToggleFFXIV
                value={customSettings.hasHazards}
                onChange={handleHazardModeToggle}
                text={t('game.modes.custom.enableHazards')}
                shape="square"
            />
            <TooltipWithIconFFXIV
                text={t('game.modes.hazard.warning')}
                warning={true}
            />
        </div>

    )
}

export default HazardSelector